(() => {
  if (window.fluffdreamCartGroupsReady) return;
  window.fluffdreamCartGroupsReady = true;

  document.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-cart-group-action]');
    if (!control) return;

    const keys = (control.dataset.cartGroupKeys || '').split('||').filter(Boolean);
    if (keys.length === 0) return;

    event.preventDefault();

    const action = control.dataset.cartGroupAction;
    const currentQuantity = Number(control.dataset.cartGroupQuantity || 0);
    const nextQuantity = action === 'remove' ? 0 : Math.max(0, currentQuantity + (action === 'increase' ? 1 : -1));
    const updates = {};

    keys.forEach((key, index) => {
      updates[key] = index === 0 ? nextQuantity : 0;
    });

    control.setAttribute('aria-disabled', 'true');

    try {
      const rootUrl = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootUrl}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) throw new Error('Unable to update grouped cart item.');
      window.location.reload();
    } catch (error) {
      control.removeAttribute('aria-disabled');
      console.error(error);
    }
  });
})();
